import React from 'react';

export default (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M16.0001 7.33337H14.6667V11.3334H16.0001V7.33337Z" fill="currentColor"/>
      <path d="M8.82741 10.4866C8.56475 10.6066 8.28675 10.6666 8.00008 10.6666C7.71341 10.6666 7.43541 10.6066 7.17341 10.4873L2.66675 8.4386V11.9999C2.66675 13.7506 5.34941 14.6666 8.00008 14.6666C10.6507 14.6666 13.3334 13.7506 13.3334 11.9999V8.43927L8.82741 10.4866Z" fill="currentColor"/>
      <path d="M15.6093 4.72657L8.276 1.39324C8.10067 1.31391 7.9 1.31391 7.72467 1.39324L0.391333 4.72657C0.152667 4.83457 0 5.07124 0 5.33324C0 5.59524 0.152667 5.83191 0.390667 5.93991L7.724 9.27324C7.812 9.31324 7.906 9.33324 8 9.33324C8.094 9.33324 8.188 9.31324 8.276 9.27324L15.6093 5.93991C15.8473 5.83191 16 5.59524 16 5.33324C16 5.07124 15.8473 4.83457 15.6093 4.72657Z" fill="currentColor"/>
    </g>
  </svg>
);
